import type { IComponent } from "app/@types/ISwSettings";
import type { ICountryObject } from "app/services/CountryService";
import CountryService from "app/services/CountryService";

export const enrichCountriesWithComponentData = (
    currentComponent: Readonly<IComponent>,
    countries: readonly ICountryObject[],
): readonly ICountryObject[] => {
    const {
        resources: { Countries },
    } = currentComponent;

    const componentAllowedCountriesIds: Set<number> = new Set(Countries);

    const enrichCountryObject = CountryService.enrichCountryAttributes({
        allowedCountriesIds: componentAllowedCountriesIds,
        mobileWebAllowedCountriesIds: new Set(),
    });

    return countries.map(enrichCountryObject);
};
